import { BaseEntity } from "yt-ng-framework";

export class TrosakDokument extends BaseEntity{

    constructor(){
        super();
    }
    PodVrstaDokumentaStavkaID: number = null;
    KomitentID: number = null;
    Broj: string = null;
    Datum: Date = null;
    BrojFakture: string = null;
    DatumFakture: Date = null;
    DatDpo: Date = null;
    Model: string = null;
    PozivBrojOdobrenja: string = null;
    PdvVisa: number = null;
    PdvNiza: number = null;
    PdvVisaBezOdbit: number = null;
    PdvNizaBezOdbit: number = null;
    DelovodniBroj: string=null;
    Url: string = null;
    BrojDokumenta: string = null;

    Deserialize(input: any){
        super.Deserialize(input);
        this.ID = input.ID;
        this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
        this.KomitentID = input.KomitentID;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.BrojFakture = input.BrojFakture;
        this.DatumFakture = input.DatumFakture;
        this.DatDpo = input.DatDpo;  
        this.Model = input.Model;
        this.PozivBrojOdobrenja = input.PozivBrojOdobrenja;
        this.PdvVisa = input.PdvVisa;  
        this.PdvNiza = input.PdvNiza;  
        this.PdvVisaBezOdbit = input.PdvVisaBezOdbit;  
        this.PdvNizaBezOdbit = input.PdvNizaBezOdbit;  
        this.DelovodniBroj = input.DelovodniBroj;   
        this.BrojDokumenta = input.BrojDokumenta;  
        
        return this;
    }

    Serialize(input: TrosakDokument){
        return input;
    }

    GetInstance(){
        return this;
    }
}